// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__POx1s","loader-appearing":"Loader_loader-appearing__J6YUf"};